export default __webpack_public_path__ + "static/media/contactus-bg3.c7a03f45.jpg";